export const ID = '1dd85e9e-15f4-4ec0-932b-d4ca49cf6fdb';

export const NAME = 'Name, Address, Phone: Facility';
